
import { Component, Vue } from "vue-property-decorator";
import AdministrationHeader from "@/components/administration/AdministrationHeader.vue";
import { Getter } from "vuex-class";
import { ICountryConfig } from "@/entities";
import WarningModal from "@/components/common/WarningModal.vue";

@Component({
  name: "administration-page",
  components: {
    AdministrationHeader,
    WarningModal,
  },
})
export default class AdministrationPage extends Vue {
  @Getter("getCountryConfig") countryConfig: ICountryConfig | undefined;

  constructor() {
    super();
  }

  async mounted(): Promise<void> {
    if (this.countryConfig?.Administration.ShowWarning) {
      this.$nextTick(() => {
        this.$bvModal.show("warning-modal");
      });
    }
  }
}
